import {
    ajaxJSON,
    ajaxJSONWithTask,
    areAllEmptyOrNull,
    isAnyEqualToFirst,
    isEmptyOrNull,
    isNotEmptyOrNull,
    isNullOrUndefined,
    namaCompare
} from "../common/NamaCommon";
import * as CommonConstants from "../constants/CommonConstants";
import * as GUIDevMode from "../constants/GUIDevMode";
import * as NamaURLS from "../constants/NamaURLS";
import {currentLoginInfo, currentUserId, LoginPresenter} from "./LoginPresenter";
import * as CriteriaValidatorApplicability from "../constants/CriteriaValidatorApplicability";
import * as errors from "../common/ErrorsNotification";
import * as notifier from "../common/ErrorsNotification";
import {lastServerLog_, onCreateTroubleTicketClick} from "../common/ErrorsNotification";
import {stringify} from "../common/NamaJSON";
import {getOrAdd, join} from "../common/CollectionsUtility";
import * as MenuTargetType from "../constants/MenuTargetType";
import * as URLRequestParameters from "../constants/URLRequestParameters";
import * as DomainBaseFieldIDs from "../constants/DomainBaseFieldIDs";
import {NamaKendoWindow} from "../views/NamaKendoWindow";
import FieldInfoTemplate from "../compiled-templates/FieldInfoTemplate";
import {translateIdAr, translateIdEn} from "../common/Translator";
import {encode} from "../common/Base64";
import {NamaRouterInstance} from "../routing/NamaRouter";
import {ListPresenter} from "../routing/ListPresenter";
import {EditPresenter} from "../routing/EditPresenter";
import {substringBeforeLast, toCSVLineWithSep} from "../common/StringUtils";
import {findFieldMetadata} from "../common/Metadata";
import {showTooltip} from "../common/TooltipUtil";
import {setStaticYearEnd, setStaticYearStart} from "../common/ExpressionEditUtility";

/**
 *
 * @type {namaTypes.CustomGUIPartsReponse}
 */
let customGUISettings = null;
let availableModules = null;
let rootReportGroups = [];
let _showIds = false;
let _showFieldInfo = false;
let serverLogActive;
let dimensionConfigurations;
let entityTypesMetadata = null;
let simpleEntityTypesMetadata = null;
/**
 *
 * @type {namaTypes.DTOAutoDashboardsAndReports}
 */
let autoDashboardsAndReports = null;
let dashboardGroups = new Map();
/**
 *
 * @type {string[]}
 */
export let sortedAllEntityTypes = null;
export let sortedSimpleAndOtherAllEntityTypes = null;
let sortedAllDisabledFeatures = null;
export let masterFileEntityTypes = null;
export let documentFileEntityTypes = null;
let allFeatures = null;
let installedModuleIDs = null;
let displayCriticalCount = 0;
/**
 *
 * @type {namaTypes.LoginAndGUIPartsResponse}
 */
let loginSettings = null;
/**
 *
 * @type {Map.<String,namaTypes.ReviseSettings>}
 */
let entitiesReviseLevelsMap = new Map();
/**
 *
 * @type {Map.<String,namaTypes.FieldAllowedValueInfo>}
 */
let fieldAllowedValuesMap = new Map();
/**
 *
 * @type {Map.<String,Boolean>}
 */
let isPrintPossibleMap = new Map();
let rootReportGroupsMergedWithAuto = false;

export function fetchCriticalMsgs() {
    let customGUISettings = getCustomGUISettings();
    if (!customGUISettings)
        return null;
    if (!customGUISettings.criticalSystemMessages)
        return null;
    displayCriticalCount++;
    if (displayCriticalCount <= 3)
        return customGUISettings.criticalSystemMessages;
}

/**
 *
 * @param {namaTypes.LoginAndGUIPartsResponse} settings
 */
export function onLogin(settings) {
    loginSettings = settings;
    customGUISettings = settings.customGUIPartsReponse;
    setStaticYearStart(customGUISettings.tooltipsAndReportsAndRevise.calendarYearStart)
    setStaticYearEnd(customGUISettings.tooltipsAndReportsAndRevise.calendarYearEnd)
    if (customGUISettings.criticalSystemMessages && customGUISettings.criticalSystemMessages.length) {
        displayCriticalCount++;
        if (displayCriticalCount <= 3)
            notifier.showErrors(customGUISettings.criticalSystemMessages, null, 0);
    }

    availableModules = settings.moduleList;
    rootReportGroups = settings.rootReportGroups;
    availableModules.sort((o1, o2) => namaCompare(o1, o2));
    sortedAllEntityTypes = [];
    sortedSimpleAndOtherAllEntityTypes = [];
    entityTypesMetadata = new Map();
    simpleEntityTypesMetadata = new Map();
    masterFileEntityTypes = [];
    documentFileEntityTypes = [];
    allFeatures = [];
    sortedAllDisabledFeatures = [...settings.loginInfo.userPreventedEntities, ...settings.loginInfo.userPreventedFeatures];
    sortedAllDisabledFeatures.sort();
    let disabledEntities = [];
    entitiesReviseLevelsMap = new Map();
    installedModuleIDs = [];
    for (let module of availableModules) {
        module.entitiesMetaData.entityTypesMetaData.sort((o1, o2) => namaCompare(o1.entityType, o2.entityType));
        installedModuleIDs.push(module.moduleId, ...module.embededModules)

        allFeatures.push(...module.definedFeatures);
        for (let entity of module.entitiesMetaData.entityTypesMetaData) {
            entityTypesMetadata.set(entity.entityType, entity);
            if ((entity.relatedToFeature && sortedAllDisabledFeatures.binaryContains(entity.relatedToFeature)) || sortedAllDisabledFeatures.binaryContains(entity.entityType)) {
                disabledEntities.push(entity.entityType);
            } else {
                sortedAllEntityTypes.push(entity.entityType);
                sortedSimpleAndOtherAllEntityTypes.push(entity.entityType);
                if (entity.isDocument)
                    documentFileEntityTypes.push(entity.entityType);
                else
                    masterFileEntityTypes.push(entity.entityType);
            }
        }
        for (let simpleEntityCodeMetaData of module.entitiesMetaData.simpleEntitiesMetaData) {
            simpleEntityTypesMetadata.set(simpleEntityCodeMetaData.entityType, simpleEntityCodeMetaData);
            sortedSimpleAndOtherAllEntityTypes.push(simpleEntityCodeMetaData.entityType);
        }
    }
    if (settings.customGUIPartsReponse.modules) {
        for (let module of settings.customGUIPartsReponse.modules) {
            if (!installedModuleIDs.contains(module))
                installedModuleIDs.push(module);
        }
    }
    sortedAllDisabledFeatures.push(...disabledEntities);
    sortedAllDisabledFeatures.sort();
    sortedAllEntityTypes.sort()
    installedModuleIDs.sort();
    sortedSimpleAndOtherAllEntityTypes.sort();
    let legId = currentLoginInfo().dimensions.legalEntity.id;
    let sectorId = currentLoginInfo().dimensions.sector.id;
    let branchId = currentLoginInfo().dimensions.branch.id;
    let deptId = currentLoginInfo().dimensions.department.id;
    let anaLysisId = currentLoginInfo().dimensions.analysisSet.id;
    ajaxJSON(NamaURLS.FetchDimsConfig, {
            request: JSON.stringify({
                userId: currentUserId(),
                barCodeOn: isBarcodeOn(),
            })
        }, (result) => {
            dimensionConfigurations = result.data;
            if (dimensionConfigurations == null)
                dimensionConfigurations = {};
        }
    );
    if (settings.customGUIPartsReponse.useBackgroundImage) {
        let ignoredStyle = `body {background-repeat:no-repeat;background-size:contain;background-position:center;
        background-image: url("${GUIDevMode.APP_URL}image.download?fileID=${CommonConstants.BG_IMAGE}&&${URLRequestParameters.LEGAL_ENTITY}=${legId}&&${URLRequestParameters.SECTOR}=${sectorId}&&${URLRequestParameters.BRANCH}=${branchId}&&${URLRequestParameters.DEPARTMENT}=${deptId}&&${URLRequestParameters.ANALYSIS_SET}=${anaLysisId}")`
    }
}

export function getDimensionConfigurations() {
    return dimensionConfigurations;
}

export function fillAutoDashboardsAndReports(result, callBack) {
    autoDashboardsAndReports = result.data;
    getDashboardGroupItemsFromMenu(callBack);
}

/**
 *
 * @param  {namaTypes.DTOMenuItem} item
 */
export function fetchTargetType(menuItem) {
    if (!menuItem.target)
        return null;
    return menuItem.target.type;
}

/**
 *
 * @param  {namaTypes.DTOMenuItem} item
 */
export function fetchTargetRecord(menuItem) {
    if (!menuItem.target)
        return null;
    return menuItem.target.targetRecord;
}

function getDashboardGroupItemsFromMenu(callBack) {
    let allDashGroups = currentLoginInfo().menu.items
        .filter(menuItem => MenuTargetType.DashboardsGroup === fetchTargetType(menuItem))
        .map(menuItem => fetchTargetRecord(menuItem));
    if (autoDashboardsAndReports)
        allDashGroups.push(...autoDashboardsAndReports.autoDashboardGroups);
    if (isEmptyOrNull(allDashGroups)) {
        if (callBack) {
            callBack();
            return;
        }
    }
    let all = [];
    all.push(...allDashGroups);

    ajaxJSON(NamaURLS.FetchDashboardGroupItems, {data: JSON.stringify(all)}, (result) => {
            result.list.forEach(dashboard => addDashboardToGroup(dashboard));
            if (callBack)
                callBack();
        }
    );

}

function addDashboardToGroup(dashboard) {
    if (!dashboard)
        return;
    let ownerGroup = dashboard.extraData[DomainBaseFieldIDs.DashBoard_details_dashBoardGroup];
    if (!ownerGroup)
        return;
    getOrAdd(ownerGroup, dashboardGroups).push(dashboard);
}

export function getAutoDashBoardGroups() {
    if (!autoDashboardsAndReports)
        return [];
    let autoDashboardGroups = autoDashboardsAndReports.autoDashboardGroups || [];
    let orderInMenu = DomainBaseFieldIDs.DashBoardGroup_orderInMenu;
    autoDashboardGroups.sort((o1, o2) => namaCompare(o1.extraData[orderInMenu], o2.extraData[orderInMenu]));
    return autoDashboardGroups;
}

/**
 *
 * @param {string} entityType
 * @return {namaTypes.EntityTypeMetaData}
 */
export function getEntityTypeMetadata(entityType) {
    return entityTypesMetadata.get(entityType);
}

export function isDocument(entityType) {
    return getEntityTypeMetadata(entityType) ? getEntityTypeMetadata(entityType).isDocument : false;
}

export function isMasterFile(entityType) {
    return !isDocument(entityType);
}

export function isSimpleEntity(entityType) {
    return simpleEntityTypesMetadata.get(entityType) != null;
}

export function isEntityEnabled(entityType) {
    return !entityType || isSimpleEntity(entityType) || sortedAllEntityTypes.binaryContains(entityType);
}

export function hasAltCode(entityType) {
    let metadata = getEntityTypeMetadata(entityType);
    return metadata && metadata.withAltCode;
}

export function getCodeMetadata(entityType) {
    return getEntityTypeMetadata(entityType).codeMetaData;
}

/**
 *
 * @return {namaTypes.TemplateMetadata[]}
 */
export function getTemplates() {
    return customGUISettings.templates;
}

/**
 *
 * @return {string[]}
 */
export function getAllEntityTypes() {
    return sortedAllEntityTypes;
}

/**
 *
 * @param {string} moduleId
 * @return {boolean}
 */
export function isModuleLoaded(moduleId) {
    if (!moduleId)
        return true;
    return installedModuleIDs.binaryContains(moduleId)
}

/**
 *
 * @param {string} moduleId
 * @return {boolean}
 */
export function isModuleNotEmptyAndLoaded(moduleId) {
    if (!moduleId)
        return false;
    return installedModuleIDs.binaryContains(moduleId)
}

export function isFeatureEnabled(feature) {
    if (!feature)
        return true;
    if (feature.startsWith("m:"))
        return isModuleLoaded(feature.substring(2));
    if (feature.startsWith("e:"))
        return getAllEntityTypes().binaryContains(feature.substring(2));
    return !sortedAllDisabledFeatures.binaryContains(feature)
}

/**
 *
 * @param {string} entityType
 * @return {namaTypes.TemplateMetadata[]}
 */
export function getEntityTemplates(entityType) {
    return getTemplates().filter((e) => e.entityType === entityType);
}

/**
 *
 * @param {string} entityType
 * @return {namaTypes.ReviseSettings}
 */
export function findEntityMaxReviseCount(entityType) {
    let useReviseDocument = customGUISettings.tooltipsAndReportsAndRevise.useReviseDocumentForAllEntities;
    let reviseLevel = customGUISettings.tooltipsAndReportsAndRevise.defaultReviseLevel;
    /**
     *
     * @type {namaTypes.ReviseSettings}
     */
    let reviseSettings = {reviseLevel, useReviseDocument};
    let entityReviseSettings = entitiesReviseLevelsMap.get(entityType);
    if (entityReviseSettings) {
        reviseSettings.reviseLevel = entityReviseSettings.reviseLevel | reviseSettings.reviseLevel;
        reviseSettings.useReviseDocument = entityReviseSettings.useReviseDocument | reviseSettings.useReviseDocument;
    }
    return reviseSettings;
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {namaTypes.FieldAllowedValueInfo}
 */
function getFieldAllowedValues(entityType, fieldId) {
    return customGUISettings.tooltipsAndReportsAndRevise.fieldsAllowedValues.entityTypeFieldValuesMap[entityType + "." + fieldId];
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {boolean}
 */
export function isFieldValuesRestricted(entityType, fieldId) {
    let fieldAllowedValues = getFieldAllowedValues(entityType, fieldId);
    return fieldAllowedValues && fieldAllowedValues.restrict;
}

export function getActionForField(fieldId, entityType, guiPostActionsId) {
    let guiPostActions = customGUISettings.tooltipsAndReportsAndRevise.guiPostActions;
    if (guiPostActionsId)
        guiPostActions = customGUISettings.tooltipsAndReportsAndRevise.manualGuiPostActions;
    let action = guiPostActions[entityType + "." + fieldId];
    if (!action)
        action = guiPostActions[fieldId];
    return action;
}

export function isNotColorField(fieldId, entityType) {
    return customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.notColorFields.binarySearch(entityType + "." + fieldId) >= 0
        || customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.notColorFields.binarySearch(fieldId) >= 0;
}

function isTextToNaMaField(fieldId, entityType, textToLinks) {
    if (!textToLinks)
        return false;
    return textToLinks.binarySearch((entityType ? (entityType + ".") : "") + fieldId) >= 0 || textToLinks.binarySearch(fieldId) >= 0;
}

export function isTextToLinkField(fieldId, entityType) {
    return isTextToNaMaField(fieldId, entityType, customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.textToLinks);
}

export function isTextToPhoneNumberLinkField(fieldId, entityType) {
    return isTextToNaMaField(fieldId, entityType, customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.textToPhones);
}

export function isTextToEmailLinkField(fieldId, entityType) {
    return isTextToNaMaField(fieldId, entityType, customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.textToEmails);
}

export function isOpenCreate(fieldId, entityType) {
    let openCreateFields = customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.entityOpenCreateFields;
    if (!openCreateFields)
        return false;
    return openCreateFields.hasOwnProperty((entityType ? (entityType + ".") : "") + fieldId) || openCreateFields.hasOwnProperty(fieldId)
        || openCreateFields.hasOwnProperty(entityType ? (entityType + ".*") : "") || openCreateFields.hasOwnProperty("*");
}

export function fetchFieldToSetValueInForOpenCreate(fieldId, entityType) {
    let openCreateFields = customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.entityOpenCreateFields;
    if (!openCreateFields)
        return null;
    let field = openCreateFields[(entityType ? (entityType + ".") : "") + fieldId];
    if (field)
        return field;
    field = openCreateFields[fieldId];
    if (field)
        return field;
    field = openCreateFields[entityType ? (entityType + ".*") : ""];
    if (field)
        return field;
    field = openCreateFields["*"];
    return field;
}

export function isOpenInPopup(fieldId, entityType) {
    let entityOpenInPopup = customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo.entityOpenInPopup;
    if (!entityOpenInPopup)
        return false;
    return entityOpenInPopup.binarySearch((entityType ? (entityType + ".") : "") + fieldId) >= 0 || entityOpenInPopup.binarySearch(fieldId) >= 0
        || entityOpenInPopup.binarySearch(entityType ? (entityType + ".*") : "") >= 0 || entityOpenInPopup.binarySearch("*") >= 0;
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {string[]}
 */
export function getAllowedValuesFor(entityType, fieldId) {
    let fieldAllowedValues = getFieldAllowedValues(entityType, fieldId);
    return fieldAllowedValues ? fieldAllowedValues.allowedValues : [];
}

export function doesFieldHaveAllowedValues(entityType, fieldId) {
    let fieldAllowedValues = getFieldAllowedValues(entityType, fieldId);
    return fieldAllowedValues ? true : false;
}

export function getPercentageScale() {
    if (!customGUISettings.percentageFractionalDecimalPlaces)
        return CommonConstants.PERCENTAGE_SACLE;
    return customGUISettings.percentageFractionalDecimalPlaces;
}

export function getPrintUsingNamaServer() {
    return customGUISettings.printUsingNamaServer || currentLoginInfo().directPrint;
}

export function getRateScale() {
    if (!customGUISettings.rateFractionalDecimalPlaces)
        return CommonConstants.RATE_SCALE;
    return customGUISettings.rateFractionalDecimalPlaces;
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {string}
 */
export function getFieldDisplayMask(entityType, fieldId) {
    let mask = recursivelyFindMask(entityType, fieldId, customizedFieldsInfo().g2EntityFieldMasks);
    if (mask != null)
        return mask;
    return recursivelyFindMask(null, fieldId, customizedFieldsInfo().g2GenericFieldMasks);
}

function recursivelyFindMask(entityType, fieldId, map) {
    let searchId = !entityType ? fieldId : entityType + "." + fieldId;
    let mask = map[searchId];
    if (mask != null)
        return mask;
    if (fieldId === "*")
        return null;
    if (fieldId.endsWith(".*"))
        fieldId = fieldId.substring(0, fieldId.length - 2);
    if (fieldId.contains("."))
        fieldId = substringBeforeLast(fieldId, ".") + ".*";
    else
        fieldId = "*";
    return recursivelyFindMask(entityType, fieldId, map);
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {namaTypes.FieldStyle}
 */
export function getFieldStyle(entityType, fieldId) {
    let style = customizedFieldsInfo().entityFieldStyleMap[entityType + "." + fieldId];
    if (style)
        return style;
    return customizedFieldsInfo().genericFieldStyleMap[fieldId];
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {boolean}
 */
export function isSignatureField(entityType, fieldId) {
    return customizedFieldsInfo().entitySignatureFields[entityType + "." + fieldId]
        || customizedFieldsInfo().genericSignatureFields[fieldId];
}

export function fetchSignatureLineApplied(entityType1, id) {
    let customizedFieldsInfo = getCustomGUISettings().tooltipsAndReportsAndRevise.customizedFieldsInfo;
    let singInfo = customizedFieldsInfo.entitySignatureFields[entityType1 + "." + id];
    if (!singInfo)
        singInfo = customizedFieldsInfo.genericSignatureFields[id];
    return singInfo || {};
}

export function getGridPageSize() {
    let customGUISettings = getCustomGUISettings();
    if (customGUISettings == null || isNullOrUndefined(customGUISettings.linesCountInGrids) || customGUISettings.linesCountInGrids == 0)
        return 25;
    return customGUISettings.linesCountInGrids;
}

/**
 *
 * @param entityType
 * @param fieldId
 * @return {boolean}
 */
export function isRichTextField(entityType, fieldId) {
    return customizedFieldsInfo().entityRichTextFields.binaryContains(entityType + "." + fieldId)
        || customizedFieldsInfo().genericRichTextFields.binaryContains(fieldId);
}


/**
 *
 * @param entityType
 * @param fieldId
 * @return {boolean}
 */
export function isDisabledField(entityType, fieldId) {
    return customizedFieldsInfo().entityDisabledFields.binaryContains(entityType + "." + fieldId)
        || customizedFieldsInfo().genericDisabledFields.binaryContains(fieldId);
}

/**
 *
 * @param entityType
 * @return {namaTypes.EntityMainFileInfo}
 */
export function getEntityImageInfo(entityType) {
    return customGUISettings.tooltipsAndReportsAndRevise.entityMainFileInfo.entitiesInfo[entityType];
}

/**
 *
 * @param entityType
 * @param fieldId
 * @param value
 * @return {string}
 */
export function calcFieldValueTriggeredTemplate(entityType, fieldId, value) {
    if (!value)
        return null;
    /**
     * @type {namaTypes.TemplateTriggerMetaDataList}
     */
    let triggerMetaDataList = customGUISettings.tooltipsAndReportsAndRevise.templeteMap[entityType + "." + fieldId];
    if (!triggerMetaDataList || !triggerMetaDataList.templates)
        return null;
    for (let templateTrigger of triggerMetaDataList.templates) {
        if (isTemplateMatchValue(value, templateTrigger))
            return templateTrigger.templateId;
    }

    return null;
}

/**
 *
 * @param value
 * @param {namaTypes.TemplateTriggerMetaData} templateTrigger
 */
function isTemplateMatchValue(value, templateTrigger) {
    if (!templateTrigger)
        return false;
    if (value == templateTrigger.dateValue || value == templateTrigger.numericValue || value == templateTrigger.textValue || value == templateTrigger)
        return true;
    if (value.id && templateTrigger.refValue)
        return value.id == templateTrigger.refValue.id;
    return false;
}

/**
 *
 * @return {namaTypes.CustomizedFieldsInfo}
 */
function customizedFieldsInfo() {
    return customGUISettings.tooltipsAndReportsAndRevise.customizedFieldsInfo;
}

/**
 *
 * @return {namaTypes.TooltipMetadata}
 */
export function fetchTooltipMetadata() {
    return customGUISettings.tooltipsAndReportsAndRevise.tooltipMetadata;
}

export function isFifoCost() {
    return customGUISettings.tooltipsAndReportsAndRevise.costOutType === "FIFO";
}

export function allowDisablingCodeFieldWithSecurity() {
    return customGUISettings.tooltipsAndReportsAndRevise.allowDisablingCodeFieldWithSecurity;
}

export function shouldUseDetailedGridsInMobile() {
    return customGUISettings.tooltipsAndReportsAndRevise.useDetailedGridsInMobile;
}

export function getDefaultDisplayFractionalDecimalPlaces() {
    return customGUISettings.tooltipsAndReportsAndRevise.defaultDisplayDecimalPlaces;
}

export function isHijriField(fieldId, entityType) {
    if (LoginPresenter.loginInfo.hijriDate)
        return true;
    return customGUISettings.hijriFields.binaryContains(fieldId) || customGUISettings.hijriFields.binaryContains(entityType + "." + fieldId);
}

/**
 *
 * @param src
 * @return {namaTypes.DTOMenuItem}
 */
export function getMenuLineBySrc(src) {
    if (!src)
        return null;
    let menu = loginSettings.loginInfo.menu;
    for (let item of menu.items) {
        if (isAnyEqualToFirst(src, item.id, item.code))
            return item;
    }
    return null;
}

let ids = []

export function nextGUIDId() {
    if (ids.length) {
        return Promise.resolve(ids.shift());
    }
    return ajaxJSONWithTask(NamaURLS.NEW_IDS, {}, (data) => {
        ids = data;
    }).then(() => Promise.resolve(ids.shift()));
}

let codeSateLites = {DocumentBook: ["documentType"], DocumentTerm: ["documentType"], MasterGroup: ["forType"]}

export function getCodeSateLiteFields(entityType) {
    return codeSateLites[entityType] || [];
}

export function isBarcodeOn() {
    return currentLoginInfo() ? currentLoginInfo().barCodeOn : false;
}

/**
 *
 * @return {namaTypes.CustomGUIPartsReponse}
 */
export function getCustomGUISettings() {
    return customGUISettings;
}

export function isSimple(entityType) {
    return isSimpleEntity(entityType);
}

export function getEntityCustomReports(ownerId) {
    let docOrMaster = CriteriaValidatorApplicability.MasterFiles;
    if (isDocument(ownerId))
        docOrMaster = CriteriaValidatorApplicability.Documents;
    return join(getEntityCustomReports_(ownerId), getEntityCustomReports_(CriteriaValidatorApplicability.AllScreens), getEntityCustomReports_(docOrMaster));
}

function customReportsMetadata() {
    return customGUISettings.tooltipsAndReportsAndRevise.customReportsMetadata;
}

function getEntityCustomReports_(entityType) {
    let customRepMetadata = customReportsMetadata();
    let list = [];
    let indexList = customRepMetadata.indices[entityType];
    if (indexList) {
        for (let index of indexList.indices) {
            list.push(customRepMetadata.customReports[index]);
        }
    }
    return list;
}

export function hideIds() {
    _showIds = false;
}

export function shouldShowIds() {
    return _showIds;
}

export function showIds() {
    _showIds = true;
}

export function shouldShowHelpMsgs() {
    return isNotEmptyOrNull(localStorage.getItem("showHelpsIsActive"));
}

export function showFieldInfo() {
    _showFieldInfo = true;
}

export function shouldShowFieldInfo() {
    return _showFieldInfo;
}

export function currentTimeMillis() {
    let date = new Date();
    return date.getTime();
}

/**
 *
 * @param {namaTypes.PrintReportRequest} request
 */
export function isPrintingPossible(request, successCallBack) {
    let failureCallBack = () => {
        errors.showErrors("There is no form to print");
    };
    let key = printPossibleKey(request);
    let cachedResponse = isPrintPossibleMap.get(key);
    if (cachedResponse != null)
        cachedResponse ? successCallBack() : failureCallBack();
    else
        ajaxJSON(NamaURLS.IsPrintReportPossible, {
            request: stringify(request)
        }, (result) => {
            isPrintPossibleMap.set(key, result);
            isNullOrUndefined(result) ? failureCallBack() : successCallBack();
        }, (failure) => {
            isPrintPossibleMap.set(key, false);
            failureCallBack();
        });
}

/**
 *
 * @param {namaTypes.PrintReportRequest} request
 */
function printPossibleKey(request) {
    return request.entityType + CommonConstants.SEPARATOR + request.tabId + CommonConstants.SEPARATOR + request.viewName + CommonConstants.SEPARATOR + request.form;

}

export function getRootReportGroups() {
    if (rootReportGroupsMergedWithAuto || !autoDashboardsAndReports)
        return rootReportGroups;
    let autoGroups = autoDashboardsAndReports.autoReportGroups || [];
    autoGroups.sort((o1, o2) => namaCompare(o1.extraData[DomainBaseFieldIDs.ReportGroup_orderInMenu], o2.extraData[DomainBaseFieldIDs.ReportGroup_orderInMenu]));
    for (let g of autoGroups) {
        rootReportGroups.splice(getGroupIndex(g), 0, g);
    }
    rootReportGroupsMergedWithAuto = true;
    return rootReportGroups;
}

function getGroupIndex(g) {
    let o = g.extraData[DomainBaseFieldIDs.ReportGroup_orderInMenu];
    if (!o)
        return 0;
    return Math.min(rootReportGroups.length, parseInt(o) - 1);
}

export function getDashboardsOfGroup(group) {
    if (!dashboardGroups)
        return [];
    return dashboardGroups.get(group.id);
}

export function calcExtraReferenceSearchSettings(entityType) {
    let info = getCustomGUISettings().tooltipsAndReportsAndRevise.extraReferenceSearchSetting;
    if (!entityType || !info || !Object.keys(info))
        return [];
    let settings = info[entityType];
    let allScreens = info[CriteriaValidatorApplicability.AllScreens];
    let documentOrMaster = info[isMasterFile(entityType) ? CriteriaValidatorApplicability.MasterFiles : CriteriaValidatorApplicability.Documents];
    if (areAllEmptyOrNull(settings, allScreens, documentOrMaster))
        return [];
    return join(!settings ? null : settings.list, !documentOrMaster ? null : documentOrMaster.list, !allScreens ? null : allScreens.list);
}


function getInfoFor(id) {
    return window['fieldsInfo'][id];
}

export function showTooltip_(entityType, id, lneNum, owner) {
    return showTooltip(entityType, id, lneNum, owner);
}

let dmMap = new Map();

/***
 *
 * @param owner
 * @param fieldId
 * @param info {namaTypes.DMEntity}
 * @param referenceTable
 * @param entityType
 */
function showFieldInfoWithDM(owner, fieldId, info, referenceTable, entityType) {
    let allowedValues = "";
    let enumTypeName = "";
    if (owner && owner.metaData) {
        let fieldMetaData = findFieldMetadata(fieldId, owner.metaData);
        if (fieldMetaData && fieldMetaData.allowedValues)
            allowedValues = toCSVLineWithSep(",", fieldMetaData.allowedValues);
        if (fieldMetaData && fieldMetaData.enumTypeName)
            enumTypeName = fieldMetaData.enumTypeName;
    }
    let columnAndTable = null;
    for (let p of info.properties) {
        if (p.fullName === fieldId) {
            columnAndTable = {table: info.tableName, column: p.columnName};
            break;
        }
    }
    if (!columnAndTable) {
        for (let d of info.details) {
            if (!fieldId.startsWith(d.fullName + "."))
                continue;
            for (let p of d.properties) {
                if (p.fullName === fieldId) {
                    columnAndTable = {table: d.tableName, column: p.columnName};
                    break;
                }
            }
            break;
        }
    }
    if (!columnAndTable)
        return;
    let table = columnAndTable.table;
    let column = columnAndTable.column;
    let container = $(FieldInfoTemplate({
        fieldId: fieldId,
        table: table,
        column: column,
        refTable: referenceTable || "",
        arabic: translateIdAr(entityType + "." + fieldId),
        english: translateIdEn(entityType + "." + fieldId),
        namaRep: "NamaRep.name(\"" + translateIdAr(entityType + "." + fieldId) + "\",\"" + translateIdEn(entityType + "." + fieldId) + "\")",
        namaRepTranslate: "NamaRep.translate(\"" + entityType + "." + fieldId + "\")",
        fColumn: "$F{" + column + "}",
        allowedValues: allowedValues,
        enumTypeName: enumTypeName,
    }));
    container.css('direction', 'ltr');
    let dialog = new NamaKendoWindow("Field Info", null, null, "30%");
    dialog.height = "50%";
    dialog.infoForField = fieldId;
    dialog.addDataWidget(container);
    dialog.showWindow();
    dialog.kendowWindow.wrapper.css("direction", "ltr");
}

export function showFieldInfoFor(entityType, fieldId, referenceTable, e, owner) {
    if (!shouldShowFieldInfo())
        return;
    e.preventDefault();
    let info = dmMap.get(entityType);
    if (info) {
        showFieldInfoWithDM(owner, fieldId, info, referenceTable, entityType);
    } else {
        $.getJSON('https://www.namasoft.com' + subReleasesDMUrlPrefix() + '/dm/dm/' + entityType + ".js", function (dmArray) {
            dmMap.set(entityType, info = dmArray[0]);
            showFieldInfoWithDM(owner, fieldId, info, referenceTable, entityType);
        });
    }
}

function subReleasesDMUrlPrefix() {
    if (getCustomGUISettings().tooltipsAndReportsAndRevise.subRelease)
        return "/sub-releases/" + getCustomGUISettings().tooltipsAndReportsAndRevise.subRelease;
    return "";
}

export function isServerLogActive() {
    return serverLogActive;
}

export function activateServerLog() {
    serverLogActive = true;
}

let lastLogDialog;

export function showLastServerLog() {
    let log = lastServerLog_() ? lastServerLog_() : "";
    let fieldSetter = CommonConstants.BASE64_PREFIX + encode(
        DomainBaseFieldIDs.CRMDevelopmentRequest_concernedEntity + ":=" + getCurrentEntity() + "--"
        + DomainBaseFieldIDs.CRMDevelopmentRequest_applicationLog + ":=" + log);
    let content = $(`
        <div class="h-100">
        <div class="d-flex justify-content-between" style="height: 90%">
        <textarea id="logTextArea" class='w-100 h-100' disabled>${log}</textarea>
        </div>
        <div class="mt-1 d-flex justify-content-between" style="height: 10%">
            <a id="createTroubleTicket" href='https://crm.namasoft.com/erp/#edit:view/NEW&entity/CRMDevelopmentRequest&fields/${fieldSetter}'>Create Development Request</a>
            <a id="copyToClipboard" role="button" title='${translateId("copy")}'>Copy</a>
        </div>
        </div>`);
    content.find("#copyToClipboard").on("click", function (e) {
        e.preventDefault();
        let target = $(content).find("#logTextArea");
        if (!navigator.clipboard) {
            target.focus();
            target.setSelectionRange(0, target.value.length);
            document.execCommand("copy");
        } else {
            navigator.clipboard.writeText($(target).val());
        }
    });
    content.find("#createTroubleTicket").on("click", function (e) {
        e.preventDefault();
        onCreateTroubleTicketClick();
    });
    if (!lastLogDialog)
        lastLogDialog = new NamaKendoWindow("", null, null, "30%");
    lastLogDialog.height = "50%";
    updateLogDialogText(content);
    lastLogDialog.showWindow(() => lastLogDialog.content.css("overflow", "hidden"));
    lastLogDialog.kendowWindow.wrapper.css("direction", "ltr");
}

function updateLogDialogText(logContent) {
    if (!lastLogDialog)
        return;
    lastLogDialog.content.html("");
    lastLogDialog.content.append(logContent);
}

function getCurrentEntity() {
    let current = NamaRouterInstance.currentPresenter;
    if (current instanceof ListPresenter || current instanceof EditPresenter)
        return current.entityType
    return "";
}

export function getGridColors() {
    if (customGUISettings == null)
        return new Map();
    return customGUISettings.gridColoursMap
}

export function shouldShowSearchInForTopPanel() {
    if (customGUISettings == null)
        return false;
    return customGUISettings.tooltipsAndReportsAndRevise.showSearchInForTopPanel;
}

export function mustSelectEntityInSearchInBeforeSearchOnServer() {
    if (customGUISettings == null)
        return false;
    return shouldShowSearchInForTopPanel() && customGUISettings.tooltipsAndReportsAndRevise.mustSelectEntityInSearchInBeforeSearchOnServer;
}

export function fixMenuAsSideBarFromGlobalConfig() {
    if (customGUISettings == null)
        return false;
    return customGUISettings.tooltipsAndReportsAndRevise.fixMenuAsSideBar || false;
}